import { gql } from '@apollo/client';

export const CLICKED_TEMPLATE_MUTATION = gql`
  mutation ClickedTemplate($id: Int!) {
    clickedTemplate(id: $id) {
      id
    }
  }
`;